import { CheckListItem } from "./checkListItem";
import { useEffect, useState } from "react";
import { CoffeCupIcon, FindItemIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { TextInput } from "../../../components/textInput/textInput";
import { useParams } from "react-router";
import SuperAdminAPI from "../../../api/SuperAdminAPI";
import AdminAPI from "../../../api/AdminAPI";

import styles from "./adminCheckList.module.css";

import { Text } from "../../../components/text/text";

export const CafeAdminCheckListPage = () => {
    const [items, setItems] = useState([]);
    const [searchField, setSearchField] = useState("");

    const [isDailyTasks, setIsDailyTasks] = useState(true);
    const { cafeId } = useParams();

    const [adminId, setAdminId] = useState(null);
    const [adminChecklistId, setAdminChecklistId] = useState(null);
    useEffect(() => {
        if (!cafeId) return;
        SuperAdminAPI
            .fetchCafeAdminInfo(cafeId)
            .catch(console.error)
            .then(res => {
                setAdminId(res.userId);
                return AdminAPI.fetchAdminChecklistID(res.userId);
            })
            .then(res => setAdminChecklistId(res.id))
            .catch(console.error);
    }, [cafeId]);

    useEffect(() => {
        if (isDailyTasks) {
            if (!adminChecklistId) return;
            AdminAPI
                .fetchAdminDailyTasks(adminChecklistId)
                .then(setItems)
                .catch(console.error);
        } else {
            if (!adminId) return;
            AdminAPI
                .fetchAdminReccurentTasks(adminId)
                .then(setItems)
                .catch(console.error);
        }

    }, [adminChecklistId, adminId, isDailyTasks]);

    return (
        <>
            <AdminHeader title="Задачи админа" />
            <TextInput value={searchField} setValue={setSearchField} leftContent={<FindItemIcon />} />

            <div className={styles.view_type_selector}>
                <Button
                    view="thin"
                    type={isDailyTasks ? "primary" : "secondary"}
                    text="Дневные"
                    onClick={() => {
                        setItems([]);
                        setIsDailyTasks(true);
                    }}
                />

                <Button
                    view="thin"
                    type={!isDailyTasks ? "primary" : "secondary"}
                    text="Повторяющиеся"
                    onClick={() => {
                        setItems([]);
                        setIsDailyTasks(false);
                    }}
                />
            </div>

            {
                items.length === 0 &&
                <div className={styles.no_elements_placeholder}>
                    <CoffeCupIcon className={styles.no_elements_icon} />
                    <Text as="div" variant="body" className={styles.no_elements_text} size={16} weight={700}>
                        У Вас еще нет задач.
                    </Text>
                </div>
            }

            {
                items.length > 0 &&
                <div className={styles.check_list_items}>
                    {
                        items.filter(el => el.taskText.toLowerCase().includes(searchField.toLowerCase().trim())).map((item) => (
                            <CheckListItem key={item.id} data={item} isDailyTasks={isDailyTasks} />
                        ))
                    }
                </div>
            }
        </>
    )
}
